import { Radio } from "@mui/material";
import React, { FC } from "react";
import { IRadioInput } from "./IRadioInput";
import styles from "./RadioInput.module.scss";

const RadioInput: FC<IRadioInput.IProps> = ({
    radioProps,
    label,
    info,
    rightChild,
}) => {
    return (
        <div className={styles.root}>
            <div className={styles.leftContainer}>
                <Radio
                    classes={{
                        root: styles.radio,
                        checked: styles.checked,
                    }}
                    {...radioProps}
                />
                <div>
                    <div className={styles.label}>{label}</div>
                    {info ? <div className={styles.info}>{info}</div> : null}
                </div>
            </div>

            <div className={styles.rightChild}>{rightChild}</div>
        </div>
    );
};

export default RadioInput;
